import * as React from 'react';
import { ButtonProps } from '@mui/material';
import Button from '../Components/Button';
import Defer from './defer';

interface FormButtonProps {
  // No need for 'disabled' or 'mounted' if you're not using them
}

function FormButton<C extends React.ElementType>(
  props: FormButtonProps & ButtonProps<C>
) {
  const { ...others } = props;

  // The button will always be enabled
  return (
    <Button
      type="submit"
      variant="contained"
      {...others} // Spread the remaining props, including 'component' if present
    />
  );
}

export default Defer(FormButton);

